// Flag de diagnóstico: só existe com "?dbg=1" na URL. Módulo separado para que a telemetria e o
// gravador de travadinhas possam ler a flag sem importar um ao outro.
export const DBG_ENABLED: boolean = (() => {
  try {
    return typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('dbg') === '1';
  } catch {
    return false;
  }
})();

/** ?dbg=1&clean=1: o gravador e as sondas funcionam, mas sem atualização de DOM por setInterval, sem painel do
 * profiler e sem r3f-perf; o log só é montado ao tocar "Copiar log". Mede quanto da travada é peso do diagnóstico. */
export const DBG_CLEAN: boolean = (() => {
  try {
    return DBG_ENABLED && new URLSearchParams(window.location.search).get('clean') === '1';
  } catch {
    return false;
  }
})();
